"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.headers = exports.getToken = void 0;
var cookie_1 = __importDefault(require("cookie"));
var const_1 = require("remota-common/const");
var util_1 = require("remota-common/util");
var getToken = function () {
    if (window && window.document && window.document.cookie) {
        var parsed = cookie_1.default.parse(window.document.cookie);
        return "Bearer ".concat(parsed[const_1.TOKEN_COOKIE_NAME]);
    }
    else {
        return undefined;
    }
};
exports.getToken = getToken;
var headers = function (other) {
    var _a;
    if (other === void 0) { other = {}; }
    return (0, util_1.omitUndefined)(__assign((_a = { Accept: "application/json" }, _a[const_1.TOKEN_HEADER_KEY] = (0, exports.getToken)(), _a), other));
};
exports.headers = headers;
// Mirrors axios's default param encoding so existing backends keep receiving the
// same query strings: arrays as `key[]=a&key[]=b`, `null`/`undefined` skipped,
// Dates as ISO strings, objects JSON-stringified.
var encode = function (value) {
    return encodeURIComponent(value)
        .replace(/%3A/gi, ":")
        .replace(/%24/g, "$")
        .replace(/%2C/gi, ",")
        .replace(/%20/g, "+")
        .replace(/%5B/gi, "[")
        .replace(/%5D/gi, "]");
};
var buildQuery = function (params) {
    var e_1, _a, e_2, _b;
    if (!params || typeof params !== "object") {
        return "";
    }
    var parts = [];
    try {
        for (var _c = __values(Object.keys(params)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            var rawValue = params[key];
            if (rawValue === null || typeof rawValue === "undefined") {
                continue;
            }
            var isArray = Array.isArray(rawValue);
            var serializedKey = isArray ? "".concat(key, "[]") : key;
            var values = isArray ? rawValue : [rawValue];
            try {
                for (var values_1 = (e_2 = void 0, __values(values)), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                    var value = values_1_1.value;
                    var serialized = void 0;
                    if (value instanceof Date) {
                        serialized = value.toISOString();
                    }
                    else if (value !== null && typeof value === "object") {
                        serialized = JSON.stringify(value);
                    }
                    else {
                        serialized = String(value);
                    }
                    parts.push("".concat(encode(serializedKey), "=").concat(encode(serialized)));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (values_1_1 && !values_1_1.done && (_b = values_1.return)) _b.call(values_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parts.join("&");
};
// Only plain objects and arrays are JSON-encoded (mirrors axios). Strings,
// FormData, URLSearchParams, Blob, etc. are left for `fetch` to handle so it
// sets the correct Content-Type and serialization — JSON.stringify'ing those
// corrupts them (e.g. JSON.stringify(new FormData()) is "{}").
var isJsonBody = function (data) {
    if (Array.isArray(data)) {
        return true;
    }
    if (typeof data !== "object" || data === null) {
        return false;
    }
    var proto = Object.getPrototypeOf(data);
    return proto === Object.prototype || proto === null;
};
// axios parsed the body as JSON when it could and fell back to raw text; preserve that.
var parseBody = function (raw) {
    if (!raw) {
        return undefined;
    }
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return raw;
    }
};
// TODO: ステータスコード等を捨ててしまっているのでなんとかしたい
var rejectHttpError = function (data) {
    if (!data || typeof data !== "object") {
        return Promise.reject(new Error(data));
    }
    else if (data.message) {
        return Promise.reject(new Error(data.message));
    }
    else {
        return Promise.reject(new Error(JSON.stringify(data)));
    }
};
exports.default = {
    request: function (method, url, params, data, additionalHeaders) {
        return __awaiter(this, void 0, void 0, function () {
            var query, requestUrl, requestHeaders, hasContentType, sendsBody, body, res, parsed, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        query = buildQuery(params);
                        requestUrl = query ? url + (url.includes("?") ? "&" : "?") + query : url;
                        requestHeaders = (0, exports.headers)(additionalHeaders);
                        hasContentType = Object.keys(requestHeaders).some(function (key) { return key.toLowerCase() === "content-type"; });
                        sendsBody = typeof data !== "undefined" && data !== null && method !== "GET";
                        if (sendsBody) {
                            if (isJsonBody(data)) {
                                body = JSON.stringify(data);
                                if (!hasContentType) {
                                    requestHeaders["Content-Type"] = "application/json";
                                }
                            }
                            else {
                                // string, FormData, URLSearchParams, Blob, etc. — let fetch serialize it
                                // and set the right Content-Type (do not force application/json).
                                body = data;
                            }
                        }
                        return [4 /*yield*/, fetch(requestUrl, {
                                method: method,
                                headers: requestHeaders,
                                body: body,
                            })];
                    case 1:
                        res = _b.sent();
                        _a = parseBody;
                        return [4 /*yield*/, res.text()];
                    case 2:
                        parsed = _a.apply(void 0, [_b.sent()]);
                        if (!res.ok) {
                            return [2 /*return*/, rejectHttpError(parsed)];
                        }
                        return [2 /*return*/, parsed];
                }
            });
        });
    },
};
